module.exports = __webpack_public_path__ + "static/media/choithramsBuglesL.3a76da37.png";